<header data-test="header">
  <mat-toolbar class="header-top-row">
    <button mat-button (click)="homeLinkClick()" class="header-top-row-button">
      <img alt="eyefinity logo" id="eyefinity-logo" ngSrc="../../assets/images/eyefinity_logo_white.svg" height="64" width="143">
    </button>
    <span class="flex-spacer"></span>
    <div class="vsp-header-buttons">
      <button *ngIf="isOptedInToModernEyefinity()" mat-button [matMenuTriggerFor]="profileMenu" id="header-top-row-profile" class="header-top-row-button classic-eyefinity-button">
        <span class="profile-icon">
          <img alt="profile icon" id="profile-icon" ngSrc="../../assets/images/person.svg" height="18" width="18">
        </span>
        <span class="classic-eyefinity-label">{{ getLoggedInUser() }}</span>
        <div class="custom-dropdown-div">
          <mat-icon class="profile-drop-down-arrow">arrow_drop_down</mat-icon>
        </div>
      </button>
      <mat-menu #profileMenu="matMenu" yPosition="below" xPosition="after" overlapTrigger="false" class="sub-menu">
        <button mat-menu-item (click)="personalizedGreetingLinkClick()" id="sub-header-profile-personalized-greeting-link" class="sub-menu-button">Personalized Greeting</button>
        <button mat-menu-item (click)="accountSettingLinkClick()" id="sub-header-profile-account-setting-link" class="sub-menu-button">Account Setting</button>
        <button mat-menu-item (click)="changePasswordLinkClick()" id="sub-header-profile-change-password-link" class="sub-menu-button">Change Password</button>
      </mat-menu>
      <button *ngIf="getLoggedInUser()" mat-button (click)="logoutLinkClick()" class="header-top-row-button classic-eyefinity-button">
        <mat-icon class="logout-icon">power_settings_new</mat-icon><span class="classic-eyefinity-label">Logout</span>
      </button>
    </div>
  </mat-toolbar>

  <mat-toolbar *ngIf="displaySecureComponent" class="top-nav" data-test="top-nav">
    <button mat-button (click)="homeLinkClick()" id="header-home-link" class="top-nav-button">Home</button>

    <button mat-button [matMenuTriggerFor]="eInsuranceMenu" id="header-legacy-einsurance-link" class="active top-nav-button active-tab">eInsurance
      <mat-icon class="drop-down-arrow">arrow_drop_down</mat-icon>
    </button>
    <mat-menu #eInsuranceMenu="matMenu" yPosition="below" xPosition="after" overlapTrigger="false" class="sub-menu">
      <button mat-menu-item (click)="eClaimLinkClick()" id="sub-header-eclaim-link" class="sub-menu-button">eClaim</button>
      <button mat-menu-item (click)="vspClaimTrackingLinkClick()" id="sub-header-vsp-claim-tracking-link" class="sub-menu-button">VSP Claim Tracking</button>
      <button mat-menu-item (click)="governmentCommercialLinkClick()" id="sub-header-gov-com-tracking-link" class="sub-menu-button">Government & Commercial Claim Tracking</button>
      <button mat-menu-item (click)="vspOnlineLinkClick()" id="sub-header-vsp-online-link" class="sub-menu-button">VSPOnline</button>
      <button mat-menu-item (click)="authTrackingLinkClick()" id="sub-header-auth-tracking-link" class="sub-menu-button">VSP Outstanding Authorizations</button>
    </mat-menu>

    <button mat-button (click)="eLabLinkClick()" id="header-eLab" class="top-nav-button">eLab</button>
    <button mat-button (click)="eBuyLinkClick()" id="header-eBuy" class="top-nav-button">eBuy</button>
    <button mat-button (click)="eLearnLinkClick()" id="header-eLearn" class="top-nav-button">eLearn</button>
    <button mat-button (click)="eWebLinkClick()" id="header-eWeb" class="top-nav-button">eWeb</button>
    <button *ngIf="!isOptedInToModernEyefinity()" mat-button (click)="eHRSolutionsLinkClick()" id="header-eHRSolutions" class="top-nav-button">EHR Solutions</button>
    <span class="flex-spacer"></span>
    <span *ngIf="isOptedInToModernEyefinity()" id="personalized-greeting" class="personalized-greeting">{{ getPersonalizedGreeting() }}</span>
  </mat-toolbar>
</header>
